// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import BlogContent from './PageComponent/BlogContent'

function Blogs() {

    useMeta({
        title: 'Blogs | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/blogs/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Blogs | Callistus Blinds',
            description:
                'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
            url: 'https://callistusblinds.com/blogs/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <BlogContent />
            <Footer />
        </div>
    );
}

export default Blogs;
